/**
 @author xiaoye
 @date 2020/4/9 2:46 下午
 */
import router from '@/router'

//token
export const TOKEN_KEY = 'token_key';
//user
export const USER_DATA = 'user_data';

import {
    GetDataViewData,
} from '@/assets/axios/dataUpload/viewSet'

//存储token
export let setToken = (token) => {
    localStorage.setItem(TOKEN_KEY, token);
};

//获取token
export let getToken = () => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) return token;
    else return ""
};

//存储用户信息
export let setUser = (user) => {
    localStorage.setItem(USER_DATA, JSON.stringify(user));
};

//获取用户信息
export let getUser = () => {
    const user = localStorage.getItem(USER_DATA);
    if (user) return JSON.parse(user);
    else return ''
};

//删除所有数据信息
export let delAllData = () => {
    setToken('');
    setUser('');
    sessionStorage.clear();
};

//Guuid
export let Guuid = () => {
    let Uid = () => {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    };

    let str = (Uid() + Uid() + Uid() + Uid() + Uid() + Uid() + Uid() + Uid());
    return str.toUpperCase();
};


//获取多维分析数据
export let getViewDpData = async (id) => {
    let data = {
        "totalCount": 0,
        "dataTabel": {
            "dt": [],
            "head": {}
        }
    };
    await GetDataViewData({dataViewID: id}).then(res => {
        if (res.code === 200) {
            data = res.data;
        }
    }).catch(() => {

    });
    return data;
};

//跳转预览页面
export let pathFullScreen = async (data) => {
    // type 1 当前页面跳转
    if(data.id != null){
        if (data.type === 1) {
            router.push({path: `/fullScreen/captchaID${data.id}/1`});
            location.reload();
        } else {
            const route = router.resolve({path: `/fullScreen/${data.id}/1`});
            window.open(route.href, '_blank')
        }
    }
};

export let pathShareScreen = async (data) => {
    // type 1 当前页面跳转
    var captchaID = window.location.href.slice(-72, -36)
    if(data.id != null){
        if (data.type === 1) {
            router.push({path: `/shareScreen/${captchaID}${data.id}`});
            location.reload();
        } else {
            const route = router.resolve({path: `/shareScreen/${captchaID}${data.id}`});
            window.open(route.href, '_blank')
        }
    }
};

//递归对象并赋值
export let  getDGCopy  = async (ob1, ob2) => {
    let obj01 = ob1;
    let obj02 = ob2;
    for (let i in obj01) {
        for (let j in obj02) {
            if (i === j) {
                if (typeof obj01[i] === 'object') {
                    if (Array.isArray(obj01[i])) {
                        obj01[i] = obj02[j];
                    } else {
                        if (JSON.stringify(obj01[i]) === '{}') {
                            obj01[i] = obj02[j];
                        } else if (!obj01[i]) {
                            obj01[i] = obj02[j];
                        } else {
                            getDGCopy(obj01[i], obj02[j])
                        }
                    }
                } else {
                    obj01[i] = obj02[j];
                }
            }
        }
    }
    return JSON.parse(JSON.stringify(obj01));
};
